import { render, staticRenderFns } from "./Desligamento.vue?vue&type=template&id=4b0a33d6"
import script from "./Desligamento.vue?vue&type=script&lang=js"
export * from "./Desligamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports